import { useEffect, useState } from 'react';
import axios from 'axios';

export default function ServiceInventory(props) {
  let loadingProductData = false;
  let productData = (props.machine.productData ?? []);
  const [productContent, setProductContent] = useState(
    <div className="ui basic loading segment">
      <div className="ui placeholder">
        <div className="paragraph">
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
        </div>
      </div>
    </div>
  );
  let content;
  let optionShowMHD = props.spontaneous ?? false;

  if (props.service.description != '') {
    content = <div>
      <h4 className='ui header'>Beschreibung</h4>
      {props.service.description}
      <div className='ui divider'></div>
    </div>
  }

  const updateProductCurrent = (materialId, amount) => {
    Object.entries(productData).forEach(([key, product]) => {
      if (product.material_id == materialId) {
        productData[key].current_amount = Math.round(Math.min(Math.max(amount, 0), product.max_amount - product.refill_amount));
      }
    });
    updateProductData();
    props.service.extraData = productData;
    props.updateExtraData(productData);
  }

  const updateBestBefore = (materialId, bestBefore) => {
    Object.entries(productData).forEach(([key, product]) => {
      if (product.material_id == materialId) {
        productData[key].best_before = bestBefore;
      }
    });
    updateProductData();
    props.service.extraData = productData;
    props.updateExtraData(productData);
  }

  const updateProductData = () => {
    let productRows = productData.map(product => <tr>
      <td>{product.name} <span className="ui small grey text">(max. {product.max_amount + (product.unit_name == "pcs" ? "" : product.unit_name)}) {product.choices.length>0 ? <span><i className='th icon'></i>{product.choices.join(', ')}</span> : ''}</span></td>
      <td>
        <div className="ui multiple progress" data-percent="10">
          <div className="green active bar" style={{ width: (Math.round((product.current_amount - product.take_back_amount) / product.max_amount * 100.0) + "%"), minWidth: "3em", display: "block" }}><div className="progress">{Math.round(product.current_amount - product.take_back_amount) + (product.unit_name == "pcs" ? "" : product.unit_name)}</div></div>
        </div>
      </td>
      <td>
        <div className='ui action input'><button className="ui disabled icon button"><i className="th icon"></i></button><button className="ui icon button" disabled={(product.current_amount - product.take_back_amount) <= 0} onClick={e => { updateProductCurrent(product.material_id, (product.current_amount - product.take_back_amount) - 1); }}><i className="minus icon"></i></button><input type="number" value={Math.round(Math.min(Math.max((product.current_amount - product.take_back_amount), 0), product.max_amount - product.refill_amount))} onChange={e => { updateProductCurrent(product.material_id, e.target.value); }} /><button className="ui icon button" disabled={product.refill_amount + (product.current_amount - product.take_back_amount) >= product.max_amount} onClick={e => { updateProductCurrent(product.material_id, (product.current_amount - product.take_back_amount) + 1); }}><i className="plus icon"></i></button></div>
        {optionShowMHD && product.best_before_supported ?
          <div className={'ui calendar icon input' + (product.best_before == null ? '' : (new Date(product.best_before) <= new Date() ? ' error' : (new Date(product.best_before) < new Date().setDate(new Date().getDate()+7) ? ' warning' : '')))}><input type="date" value={product.best_before == null ? '' : product.best_before} onChange={e => updateBestBefore(product.material_id, e.target.value)} /><i className={(product.best_before !== null ? 'link ' : 'disabled ')+"times icon"} onClick={e => updateBestBefore(product.material_id, null)}></i></div>
          : ''
        }
      </td>
    </tr>);

    setProductContent(
      <table className="ui fixed celled very compact single line table refill-table">
        <thead>
          <tr><th colSpan="3">
            Produkte
          </th>
          </tr></thead>
        <tbody>
          {productRows}
        </tbody>
      </table>
    );

  }

  useEffect(() => {
    if (productData.length == 0 && !loadingProductData) {
      loadingProductData = true;
      axios.post(process.env.REACT_APP_CUSTOM_URL + 'getProductData', { machineId: props.machine.id }).then(response => {
        productData = response.data.products;
        props.updateExtraData(productData);
        props.service.extraData = productData;
        updateProductData();
      }).catch(function (error) {
        setProductContent(<div className="ui negative message">
          <div className="header">
            Fehler
          </div>
          <p>Die Produktdaten konnten nicht geladen werden</p>
        </div>);
      });
    }
    else {
      updateProductData();
      props.service.extraData = productData;
    }
  }, []);

  return (
    <div>
      {content}
      {productContent}
      Inventur beendet?
    </div>
  );
}